// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tEY8","fullView":"styles_fullView__ErDdB"};